import { useEffect, useState } from 'react';
import { ArchivedTutorials } from '../../components';
import { useAuth } from '../../contexts/auth';

export function ArchivedTutorialsPage() {
    const { searchUserLogged } = useAuth();
    const [userLogged, setUserLogged] = useState({});

    useEffect(() => {
        async function fetchUser() {
            const user = await searchUserLogged();
            if (user) {
                setUserLogged(user);
            }
        }
        fetchUser();
    }, []);

    return <ArchivedTutorials userLogged={userLogged} />;
}